<template>
  <div>
    <div class="banner-wrap">
      <Banner class="pc-banner " :is-hitech="true" />
    </div>
    <TopBoardCategories
      :header="content.headerTxt"
      :subHeader="content.subHeaderTxt"
    />
    <AncorsNav :navItems="hitechCategories" />
    <div class="inner-wrap">
      <div class="section_inner">
        <v-layout column class="inner-content pt-3 mt-3">
          <ArticleBreadcrumbs :items="breadCrumbs" class="pr-0" />
          <v-flex>
            <v-layout wrap justify-space-between>
              <v-flex xl10 lg10 class="jobs-row" pa1>
                <v-layout wrap>
                  <v-flex v-for="(cat, i) in hitechCategories" :key="i" xs12>
                    <HitechCatItem :catItem="cat" />
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex class="ads-row">
                <!-- <div v-for="i in 2" :key="i"> -->
                <v-layout colomun wrap>
                  <v-flex>
                    <SectionCompaniesInnerPages
                      :is-hitech="true"
                      :page="'hightechPage'"
                    />
                  </v-flex>
                </v-layout>
                <!-- </div> -->
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
    </div>
  </div>
</template>



<script>
import TopBoardCategories from '@/components/CategoriesPage/TopBoardCategories';

import SectionCompaniesInnerPages from '@/components/Jobs_List/SectionCompaniesInnerPages';
import HitechCatItem from '@/components/HitechCategories/HitechCatItem';
import AncorsNav from '@/components/HitechCategories/AncorsNav';
import Banner from '@/components/Jobs_List/Banner';
import { t } from '@/store/modules/homeDrushim/constantsContent';
import SeoOptimization from '@/components/mixins/SeoOptimization';
import { HITECH_CATEGORY, SEO } from '@/lib/api.js';

export default {
  mixins: [SeoOptimization],
  layout: 'categories',
  name: 'drushimHitechPage',

  components: {
    TopBoardCategories,
    SectionCompaniesInnerPages,
    HitechCatItem,
    AncorsNav,
    Banner
  },

  data() {
    return {
      content: t('titles.hitechPage')
    };
  },
  async asyncData({ error, route, $axios }) {
    try {
      const {
        data: { data: data }
      } = await $axios.get(HITECH_CATEGORY);
      const {
        data: { data: seo }
      } = await $axios.get(`${SEO}/?pageId=35`);

      return {
        hitechCategories: data,
        seodata: {
          metaData: seo.seoModel.metaDataItems,
          pageTitle: seo.seoModel.title,
          breadCrumbsSchema: {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: 'Home page',
                item: 'https://www.drushim.co.il/'
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: 'דרושים הייטק'
              }
            ]
          }
        },
        breadCrumbs: [
          {
            name: 'home',
            value: 'דרושים',
            link: '/'
          },
          {
            name: 'hitech',
            value: 'דרושים הייטק',
            link: '/דרושים-הייטק/'
          }
        ]
      };
    } catch (e) {
      error({
        statusCode: 404,
        path: route.fullPath,
        message: 'hitech categories error: ' + e
      });
    }
  },
  head() {
    return {
      link: [
        {
          rel: 'canonical',
          href: 'https://www.drushim.co.il' + this.$route.fullPath
        }
      ],
      title: this.seodata.pageTitle,
      meta: this.seodata.metaData,
      __dangerouslyDisableSanitizers: ['script'],
      script: [
        {
          innerHTML: JSON.stringify(this.seodata.breadCrumbsSchema),
          type: 'application/ld+json'
        }
      ]
    };
  }
};
</script>


<style lang="scss" scoped>
.inner-wrap {
  min-height: 50vh;
}

.inner-content {
  padding: 0 5px;
}

.theme--light.v-list {
  background: transparent;
}

.jobs-row {
  max-width: 934px;
}

.ads-row {
  max-width: 300px;
}

.aside-ad {
  background: #3e4a54;
  text-align: center;
}

.mobile-banner {
  margin: 5px;
}

@media only screen and (min-width: 600px) {
  .inner-content {
    padding: 0;
  }
}

@media only screen and (min-width: 700px) {
  .filter-by-text {
    display: block;
  }
}

@media screen and (max-width: 1280px) {
  .jobs-row {
    max-width: 100%;
  }

  .ads-row {
    display: none;
  }
}
</style>
